module.exports = __webpack_public_path__ + "img/iconNo5.8f60c6d6.png";